var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glide-Path_-Action-Card_-Full-Plan",
    transform: "translate(-318.000000, -119.000000)",
    fill: "#35A4F2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328,119 C330.671094,119 333.182305,120.040195 335.071055,121.928945 C336.959805,123.817656 338,126.328906 338,129 C338,131.671094 336.959805,134.182305 335.071055,136.071055 C333.182305,137.959805 330.671094,139 328,139 C325.328906,139 322.817656,137.959805 320.928945,136.071055 C319.040195,134.182305 318,131.671094 318,129 C318,126.328906 319.040195,123.817656 320.928945,121.928945 C322.817695,120.040234 325.328906,119 328,119 Z M328,120.615781 C323.376953,120.615781 319.615781,124.376953 319.615781,129 C319.615781,133.623047 323.376953,137.384219 328,137.384219 C332.623047,137.384219 336.384219,133.623047 336.384219,129 C336.384219,124.376953 332.623047,120.615781 328,120.615781 Z M324.671133,125.671133 C324.986602,125.355625 325.498164,125.355625 325.813633,125.671133 L328,127.858 L330.186367,125.671133 C330.473192,125.384308 330.922014,125.358233 331.238293,125.592908 L331.328906,125.671133 C331.644375,125.986641 331.644375,126.498164 331.328906,126.813633 L329.142,129 L331.328906,131.186367 C331.615696,131.473192 331.641768,131.922014 331.407151,132.238293 L331.328945,132.328906 C331.171172,132.48668 330.964414,132.565547 330.757656,132.565547 C330.550898,132.565547 330.344102,132.48668 330.186367,132.328906 L328,130.142 L325.813672,132.328906 C325.687484,132.455125 325.529897,132.530844 325.366049,132.556083 L325.242383,132.565547 C325.035625,132.565547 324.828828,132.48668 324.671094,132.328906 C324.355586,132.013398 324.355586,131.501875 324.671094,131.186367 L326.858,129 L324.671133,126.813633 C324.384308,126.526808 324.358233,126.077986 324.592908,125.761736 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanClose);
export default __webpack_public_path__ + "static/media/plan-close.335f66e2.svg";
export { ForwardRef as ReactComponent };